import { render, staticRenderFns } from "./DashboardTouchPreview.vue?vue&type=template&id=14a2ae98&scoped=true"
import script from "./DashboardTouchPreview.vue?vue&type=script&lang=js"
export * from "./DashboardTouchPreview.vue?vue&type=script&lang=js"
import style0 from "./DashboardTouchPreview.vue?vue&type=style&index=0&id=14a2ae98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2ae98",
  null
  
)

export default component.exports